import React from 'react';
import { useParams } from 'react-router-dom';

import DemandCreateForm from 'components/Demand/DemandCreateForm/DemandCreateForm';

const DemandCreatePage: React.FC = () => {
  const { accountId = '', projectId = '', positionId = '' } = useParams();

  return <DemandCreateForm accountId={accountId} projectId={projectId} positionId={positionId} />;
};

export default DemandCreatePage;
